import { 
    StartSequenceGame as DLStart, 
    RegisterSequenceTap as DLTap, 
    FinishSequencePlayback as DLFinish, 
    ResetSequenceGame as DLReset,
    GetSequenceState as DLState,
    ShowSequenceFrontPage as DLFrontPage,
    GetSequenceHistory as DLHistory,
    ClearSequenceHistory as DLClearHistory,
    ProjectSequenceGame as DLProjectGame,
    GetSequenceThemes as DLGetThemes,
    GetSequenceTheme as DLGetTheme,
    SaveSequenceTheme as DLSaveTheme,
    DeleteSequenceTheme as DLDeleteTheme,
    GetSequenceConfig as DLGetConfig,
    SaveSequenceConfig as DLSaveConfig,
    UploadSequenceMedia as DLUploadMedia
} from './../DL/Sequence';

export const StartSequence = async (configData) => {
    return await DLStart(configData);
};

export const RegisterTap = async (screenId, matchId, colorId) => {
    return await DLTap(screenId, matchId, colorId);
};

export const FinishPlayback = async (screenId, matchId) => {
    return await DLFinish(screenId, matchId);
};

export const ResetSequence = async (screenId) => {
    return await DLReset(screenId);
};

export const GetState = async (screenId) => {
    return await DLState(screenId);
};

export const ShowFrontPage = async (screenId) => {
    return await DLFrontPage(screenId);
};

export const GetSequenceHistory = async () => {
    return await DLHistory();
};

export const ClearSequenceHistory = async () => {
    return await DLClearHistory();
};

export const ProjectGame = async (screenId) => {
    return await DLProjectGame(screenId);
};

export const GetSequenceThemes = async () => {
    return await DLGetThemes();
};

export const GetSequenceTheme = async (id) => {
    return await DLGetTheme(id);
};

export const SaveSequenceTheme = async (theme) => {
    return await DLSaveTheme(theme);
};

export const DeleteSequenceTheme = async (id) => {
    return await DLDeleteTheme(id);
};

export const GetSequenceConfig = async (screenId) => {
    return await DLGetConfig(screenId);
};

export const SaveSequenceConfig = async (config) => {
    return await DLSaveConfig(config);
};

export const UploadSequenceMedia = async (file) => {
    return await DLUploadMedia(file);
};
